<template>
  <div class="padding-bottom-xxxl">
    <div class="large margin-bottom-s" role="heading" aria-level="2">Gift Cards</div>
    <div v-html="GIFT_CARD_BALANCE.termsAndConditions"></div>
  </div>
</template>

<script setup>
import { GIFT_CARD_BALANCE } from 'config';
</script>
